import paymentInstance from '../../instance'
import paymentModalLoginInstance from '../../modalLoginInstance'

const createTerminalPaymentSession = (terminalId, totalSum, paymentSource, hasModalLogin = false) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance).post(`/terminals/${terminalId}/paymentSessions`, { totalSum, paymentSource })
}

export default createTerminalPaymentSession
